<template>
  <div class="identify">
    <!-- personal data -->
    <section>
      <el-row>
        <el-col :span="24">
          <el-form
            :model="userData"
            ref="userData"
            :rules="userrule"
            :label-width="this.$i18n.locale=='en'?'180px':'120px'"
            v-loading="userLoading"
          >
            <el-form-item
              :label="$t('personal.name')"
              prop="name"
            >
              <el-input
                v-model="userData.name"
                :disabled="editName"
              ></el-input>
              <span
                @click="editName = false"
                v-show="editName"
                class="spn"
              >{{$t('personal.edit')}}</span>
              <span :class="this.$i18n.locale=='en'?'spanwid':'spn'">
                <span
                  v-show="!editName"
                  @click="submit('userData')"
                >{{$t('personal.save')}}</span>
                &nbsp;
                <span
                  v-show="!editName"
                  @click="cancel"
                >{{$t('personal.cancel')}}</span>
              </span>
            </el-form-item>
            <el-form-item :label="$t('personal.password')">
              <span
                class="spn"
                @click="editPassword"
              >{{$t('personal.edit')}}</span>
            </el-form-item>
            <el-form-item :label="$t('personal.phone')">
              <template>
                <el-button
                  class="mini"
                  @click="bindPhone"
                  type="success"
                  :disabled="disableds"
                >{{
                  !userData.phone && typeof(userData.phone)!="undefined" && userData.phone!=0 ? $t('personal.tapbind') : $t('personal.albind')
                  }}</el-button>
                {{ userData.phone }}
                <span
                  class="spn"
                  @click="editPhone"
                >{{
                  !userData.phone && typeof(userData.phone)!="undefined" && userData.phone!=0 ? "" : $t('personal.edit')
                  }}</span>
              </template>
            </el-form-item>
            <el-form-item :label="$t('personal.email')">
              <el-button
                type="success"
                class="mini"
                @click="bindEmail"
                :disabled="disabled"
              >{{ !userData.email && typeof(userData.email)!="undefined" && userData.email!=0 ? $t('personal.tapbind') : $t('personal.albind')  }}</el-button>
              {{ userData.email }}
              <span
                class="spn"
                @click="editEmail"
              >{{
                !userData.email && typeof(userData.email)!="undefined" && userData.email!=0 ? "" : $t('personal.edit')
                }}</span>
            </el-form-item>
            <el-form-item :label="$t('personal.times')">{{
              util.timestampToTime(times)
              }}</el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <el-dialog
        :title="$t('personal.textMap')[dialogStatus]"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        v-loading="editLoading"
        :width="dialogWidth"
        class="paswidth"
        :destroy-on-close="true"
      >
        <!-- 修改密码  -->
        <el-form
           :label-width="this.$i18n.locale=='en'?'200px':'120px'"
          :model="editForm"
          ref="editForm"
          :rules="editPwdRules"
          v-show="dialogStatus == 'editPwd'"
        >
          <el-form-item
            :label="$t('personal.oldPwd')"
            prop="oldPwd"
          >
            <el-input v-model="editForm.oldPwd"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('personal.newPwd')"
            prop="newPwd"
          >
            <el-input v-model="editForm.newPwd"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('personal.conPwd')"
            prop="conPwd"
          >
            <el-input v-model="editForm.conPwd"></el-input>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button @click.native="offtap('editForm')">{{$t('personal.cancel')}}</el-button>
            <el-button
              @click="passwordTap('editForm')"
              type="success"
            >{{$t('personal.success')}}</el-button>
          </el-form-item>
        </el-form>
        <!-- 绑定手机号 -->
        <el-form
          :label-width="this.$i18n.locale=='en'?'200px':'120px'"
          :model="bindphoneForm"
          ref="bindphoneForm"
          :rules="bindphoneRules"
          :width="dialogWidth"
          v-show="dialogStatus == 'bindPho'"
        >
          <el-form-item
            style="margin-top:10px;"
            prop="phone"
            :label="$t('personal.bindphone')"
          >
            <el-input v-model="bindphoneForm.phone"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('personal.bindcode')"
            prop="code"
          >
            <el-input
              v-model="bindphoneForm.code"
              class="inputw"
            ></el-input>
            <el-button
              style="margin-left: 15px;"
              type="success"
              @click="getCode(bindphoneForm.phone)"
            >{{ code }}</el-button>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button @click.native="resetForm('bindphoneForm')">{{$t('personal.cancel')}}</el-button>
            <el-button
              @click.native="bindPhoSubmit('bindphoneForm')"
              type="success"
              size="medium"
            >{{$t('personal.bind')}}</el-button>
          </el-form-item>
        </el-form>
        <!--  修改手机号   -->
        <el-steps
          :active="active"
          align-center
          v-show="dialogStatus == 'editPho'"
        >
          <el-step
            v-for="(item, index) in $t('personal.stepData')"
            :key="index"
            :title="item.label"
            :value="item.value"
          >
          </el-step>
        </el-steps>
        <!-- 第一步 -->
        <el-form
          :label-width="this.$i18n.locale=='en'?'190px':'120px'"
          :model="editphoneForm"
          ref="editphoneForm"
          :rules="editphoneRules"
          :width="dialogWidth"
          v-show="dialogStatus == 'editPho' && active === 1"
        >
          <el-form-item class="formcenter">
            <span>{{$t('personal.editphone')}}{{
              editphoneForm.rephone.substr(0, 3) + "****" + editphoneForm.rephone.substr(7)
              }}</span>
          </el-form-item>
          <el-form-item
            :label="$t('personal.phonecode')"
            prop="code"
          >
            <el-input
              v-model="editphoneForm.code"
              class="inputw"
            ></el-input>
            <el-button
              style="margin-left: 15px;"
              type="success"
              @click="getCodephone(editphoneForm.rephone)"
            >{{ codefirst }}</el-button>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button
              type="success"
              @click="nextpho('editphoneForm')"
              v-if="dialogStatus == 'editPho' && active === 1"
            >{{$t('personal.next')}}</el-button>
          </el-form-item>
        </el-form>
        <!-- 第二步 -->
        <el-form
         :label-width="this.$i18n.locale=='en'?'190px':'120px'"
          :model="editphoneFormsec"
          ref="editphoneFormsec"
          :rules="editphoneRulessec"
          :width="dialogWidth"
          v-show="dialogStatus == 'editPho' && active === 2"
        >
          <el-form-item
            style="margin-top:10px;"
            prop="phone"
            :label="$t('personal.newphone')"
          >
            <el-input v-model="editphoneFormsec.phone"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('personal.newcode')"
            prop="code"
          >
            <el-input
              v-model="editphoneFormsec.code"
              class="inputw"
            ></el-input>
            <el-button
              style="margin-left: 15px;"
              type="success"
              @click="getCodephones(editphoneFormsec.phone)"
            >{{ codephonesecond }}</el-button>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button @click.native="resetForm('editphoneFormsec')">{{$t('personal.cancel')}}</el-button>
            <el-button
              type="success"
              @click.native="editsecPhoSubmit('editphoneFormsec')"
            >{{$t('personal.bind')}}</el-button>
          </el-form-item>
        </el-form>
        <!-- edit Email  && bind Email  dialogStatus='editEma  || bindEma'-->
        <!-- bind Email -->
        <el-form
           :label-width="this.$i18n.locale=='en'?'180px':'120px'"
          :model="bindemailForm"
          ref="bindemailForm"
          :rules="bindemailRules"
          :width="dialogWidth"
          v-show="dialogStatus == 'bindEma'"
        >
          <el-form-item
            style="margin-top:10px;"
            :label="$t('personal.bindemail')"
            prop="email"
          >
            <el-input v-model="bindemailForm.email"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('personal.bindemailcode')"
            prop="code"
          >
            <el-input
              class="inputw"
              v-model="bindemailForm.code"
            ></el-input>
            <el-button
              style="margin-left: 15px"
              type="success"
              @click="getCodes(bindemailForm.email)"
            >{{ codes }}</el-button>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button @click.native="resetForm('bindemailForm')">{{$t('personal.cancel')}}</el-button>
            <el-button
              type="success"
              @click.native="bindEmaSubmit('bindemailForm')"
            >{{$t('personal.bind')}}</el-button>
          </el-form-item>
        </el-form>
        <!-- edit email -->
        <el-steps
          :active="active"
          align-center
          direction='horizontal'
          v-show="dialogStatus == 'editEma'"
        >
          <el-step
            v-for="(item, index) in $t('personal.stepEmail')"
            :key="index"
            :title="item.label"
            :value="item.value"
          >
          </el-step>
        </el-steps>
        <!-- first -->
        <el-form
           :label-width="this.$i18n.locale=='en'?'190px':'120px'"
          :model="editemailForm"
          ref="editemailForm"
          :rules="editemailRules"
          :width="dialogWidth"
          v-show="dialogStatus == 'editEma' && active === 1"
        >
          <el-form-item class="formcenter">
            <span>{{$t('personal.editemail')}}{{
              editemailForm.reemail.replace(/(.{1}).+(.{2}@.+)/g, "$1****$2")
              }}</span>
          </el-form-item>
          <el-form-item
            :label="$t('personal.emailcode')"
            prop="code"
          >
            <el-input
              class="inputw"
              v-model="editemailForm.code"
            ></el-input>
            <el-button
              style="margin-left: 15px;"
              type="success"
              @click="getCodeemail(editemailForm.reemail)"
            >{{ codesfirst }}</el-button>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button
              type="success"
              @click="nextemail('editemailForm')"
              v-if="dialogStatus == 'editEma' && active === 1"
            >{{$t('personal.next')}}</el-button>
          </el-form-item>
        </el-form>
        <!-- second -->
        <el-form
           :label-width="this.$i18n.locale=='en'?'190px':'120px'"
          :model="editsecemailForm"
          ref="editsecemailForm"
          :rules="editsecemailRules"
          :width="dialogWidth"
          v-show="dialogStatus == 'editEma' && active === 2"
        >
          <el-form-item
            style="margin-top:10px;"
            :label="$t('personal.newemail')"
            prop="email"
          >
            <el-input v-model="editsecemailForm.email"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('personal.newemailcode')"
            prop="code"
          >
            <el-input
              class="inputw"
              v-model="editsecemailForm.code"
            ></el-input>
            <el-button
              style="margin-left: 15px;"
              type="success"
              @click="getCodeemails(editsecemailForm.email)"
            >{{ codesecond }}</el-button>
          </el-form-item>
          <el-form-item class="formcenter">
            <el-button @click.native="resetForm('editsecemailForm')">{{$t('personal.cancel')}}</el-button>
            <el-button
              type="success"
              @click.native="editEmaSubmit('editsecemailForm')"
            >{{$t('personal.bind')}}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </section>
  </div>
</template>
<script>
export default {
  name: "personal",
  data() {
    var validOldPwd = (rule, value, callback) => {
      //验证旧密码
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        callback(new Error(this.$t("checkvalid.oldPwd")));
      } else {
        callback();
      }
    };
    var validNewPwd = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        callback(new Error(this.$t("checkvalid.newPwd")));
      } else {
        callback();
      }
    };
    var conNewPwd = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        callback(new Error(this.$t("checkvalid.conPwd")));
      } else if (value !== this.editForm.newPwd) {
        callback(new Error(this.$t("checkvalid.same")));
      } else {
        callback();
      }
    };
    var phonevalid = (rule, value, callback) => {
      var rest = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!rest.test(value) || value == 0) {
        callback(new Error(this.$t("checkvalid.phone")));
      } else {
        callback();
      }
    };
    var emailvalid = (rule, value, callback) => {
      var rests = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!rests.test(value) || value == 0) {
        callback(new Error(this.$t("checkvalid.email")));
      } else {
        callback();
      }
    };
    var codevalid = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("checkvalid.code")));
      } else {
        callback();
      }
    };
    var loginaccount = (rule, value, callback) => {
  
      if (!value) {
        return callback(new Error(this.$t("checkvalid.account")));
      }else {
        callback();
      }
    };
    return {
      stepData: [
        {
          label: "验证身份",
          value: 1
        },
        {
          label: "更改手机",
          value: 2
        }
      ],
      stepEmail: [
        {
          label: "验证身份",
          value: 1
        },
        {
          label: "更改邮箱",
          value: 2
        }
      ],
      active: 1,
      backupName: null, //账户名称的备份
      userData: {
        phone: "",
        name: "",
        email: ""
      },
      userrule: {
        name: [{ validator: loginaccount, trigger: "blur" }]
      },
      // 修改密码
      editForm: {
        oldPwd: "",
        newPwd: "",
        conPwd: ""
      },
      // 修改密码规则
      editPwdRules: {
        oldPwd: [{ required: true, validator: validOldPwd, trigger: "blur" }],
        newPwd: [{ required: true, validator: validNewPwd, trigger: "blur" }],
        conPwd: [{ required: true, validator: conNewPwd, trigger: "blur" }]
      },
      times: "",
      editLoading: false,
      userLoading: false,
      editName: true,
      textMap: {
        editPwd: "修改密码",
        editPho: "修改手机号",
        editEma: "修改邮箱",
        bindEma: "邮箱绑定",
        bindPho: "手机号绑定"
      },
      dialogStatus: "",
      dialogFormVisible: false,
      code: this.$t("forgectPhone.codeStr"),
      codefirst: this.$t("forgectPhone.codeStr"),
      codephonesecond:this.$t("forgectPhone.codeStr"),
      codeTime: 60,
      codeTimes: 60,
      codes: this.$t("forgectPhone.codeStr"),
      codesfirst: this.$t("forgectPhone.codeStr"),
      codesecond: this.$t("forgectPhone.codeStr"),
      dialogWidth: "0",
      // bind phone
      bindphoneForm: {
        phone: "",
        code: ""
      },
      bindphoneRules: {
        phone: [{ required: true, validator: phonevalid, trigger: "blur" }],
        code: [{ required: true, validator: codevalid, trigger: "blur" }]
      },
      editphoneForm: {
        code: "",
        rephone: ""
      },
      editphoneRules: {
        code: [{ required: true, validator: codevalid, trigger: "blur" }]
      },
      editphoneFormsec: {
        phone: "",
        code: ""
      },
      editphoneRulessec: {
        phone: [{ required: true, validator: phonevalid, trigger: "blur" }],
        code: [{ required: true, validator: codevalid, trigger: "blur" }]
      },
      // bind email
      bindemailForm: {
        email: "",
        code: ""
      },
      bindemailRules: {
        email: [{ required: true, validator: emailvalid, trigger: "blur" }],
        code: [{ required: true, validator: codevalid, trigger: "blur" }]
      },
      // first
      editemailForm: {
        code: "",
        reemail: ""
      },
      editemailRules: {
        code: [{ required: true, validator: codevalid, trigger: "blur" }]
      },
      editsecemailForm: {
        email: "",
        code: ""
      },
      editsecemailRules: {
        email: [{ required: true, validator: emailvalid, trigger: "blur" }],
        code: [{ required: true, validator: codevalid, trigger: "blur" }]
      },
      disabled: false,
      disableds: false
    };
  },
  mounted() {
    this.userInfo();
  },
  methods: {
    // 获取用户信息
    userInfo() {
      const data = {
        token: this.$store.state.token
      };
      this.$http
        .post("/user/get_me", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              console.log(res.data);
              var tmps = res.data.data.phone;
              if (!tmps && typeof tmps != "undefined" && tmps != 0) {
                this.disableds = false;
              } else {
                this.disableds = true;
              }
              var tmp = res.data.data.email;
              if (!tmp && typeof tmp != "undefined" && tmp != 0) {
                this.disabled = false;
              } else {
                this.disabled = true;
              }
              this.userData.name = res.data.data.name;
              console.log(this.userData.name);
              this.userData.phone = res.data.data.phone;
              this.userData.email = res.data.data.email;
              this.times = res.data.data.creation_time;
              this.backupName = res.data.data;
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancel() {
      this.editName = true;
      this.userData.name = this.backupName.name; //用户名称回复默认的状态
      this.active = 1;
      this.dialogFormVisible = false;
      this.$refs["userData"].clearValidate();
    },
    // 修改账户名
    submit(userData) {
      this.$refs.userData.validate(valid => {
        if (valid) {
          const data = {
            token: this.$store.state.token,
            name: this.userData.name
          };
          this.$http
            .post("/user/edit_me", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t("checkvalid.edit"),
                    type: "success",
                    duration: 1500
                  });
                  this.editName = true;
                  this.userInfo();
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
        }
      });
    },
    // 修改登录密码
    editPassword() {
      this.dialogStatus = "editPwd";
      this.dialogWidth = "33%";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.editForm.resetFields();
      });
    },
    // 修改密码
    passwordTap(editForm) {
      console.log(this.$refs.editForm);
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const data = {
            token: this.$store.state.token,
            old_pass: this.editForm.oldPwd,
            new_pass: this.editForm.newPwd
          };
          this.$http
            .post("/user/edit_pass", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t("checkvalid.edit"),
                    type: "success",
                    duration: 1500
                  });
                  this.dialogFormVisible = false;
                  this.$router.push({
                    name: "login"
                  });
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    // 手机号
    editPhone() {
      this.active = 1;
      this.dialogStatus = "editPho";
      this.dialogWidth = "36%";
      this.dialogFormVisible = true;
      this.editphoneForm.rephone = this.userData.phone;
      if (this.$refs.editphoneForm) {
        this.$nextTick(() => {
          this.$refs.editphoneForm.resetFields();
        });
      }
    },
    bindPhone() {
      this.dialogStatus = "bindPho";
      this.dialogWidth = "36%";
      this.dialogFormVisible = true;
      if (this.$refs.bindphoneForm) {
        this.$nextTick(() => {
          this.$refs.bindphoneForm.resetFields();
        });
      }
    },
    // 绑定手机号
    bindPhoSubmit(bindphoneForm) {
      console.log(this.$refs.bindphoneForm);
      this.$refs.bindphoneForm.validate(valid => {
        if (valid) {
          console.log(222);
          const data = {
            token: this.$store.state.token,
            phone: this.bindphoneForm.phone,
            code: this.bindphoneForm.code
          };
          this.$http
            .post("/user/bind_phone", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t("checkvalid.bind"),
                    type: "success",
                    duration: 1500
                  });
                  this.dialogFormVisible = false;
                  this.userInfo();
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    resetForm(bindphoneForm) {
      this.dialogFormVisible = false;
      if (this.$refs.bindphoneForm) {
        this.$nextTick(() => {
          this.$refs.bindphoneForm.resetFields();
        });
      }
    },
    // 修改手机号-第二步
    editsecPhoSubmit(editphoneFormsec) {
      console.log(this.$refs.editphoneFormsec);
      this.$refs.editphoneFormsec.validate(valid => {
        if (valid) {
          console.log(33333);
          const data = {
            phone: this.editphoneFormsec.phone,
            code: this.editphoneFormsec.code,
            token: this.$store.state.token
          };
          this.$http
            .post("/user/bind_phone", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t("checkvalid.edit"),
                    type: "success",
                    duration: 1500
                  });
                  this.dialogFormVisible = false;
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    // bind email
    bindEmail() {
      this.dialogStatus = "bindEma";
      this.dialogWidth = "36%";
      this.dialogFormVisible = true;
      if (this.$refs.bindemailForm) {
        this.$nextTick(() => {
          this.$refs.bindemailForm.resetFields();
        });
      }
    },
    //绑定邮箱
    bindEmaSubmit(bindemailForm) {
      this.$refs.bindemailForm.validate(valid => {
        if (valid) {
          const data = {
            email: this.bindemailForm.email,
            code: this.bindemailForm.code,
            token: this.$store.state.token
          };
          this.$http
            .post("/user/bind_email", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t("checkvalid.bind"),
                    type: "success",
                    duration: 1500
                  });
                  this.dialogFormVisible = false;
                  this.userInfo();
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    editEmail() {
      //edit email
      this.active = 1;
      this.dialogStatus = "editEma";
      this.dialogWidth = "36%";
      this.dialogFormVisible = true;
      this.editemailForm.reemail = this.userData.email;
      if (this.$refs.editemailForm) {
        this.$nextTick(() => {
          this.$refs.editemailForm.resetFields();
        });
      }
    },
    // 修改邮箱
    editEmaSubmit(editsecemailForm) {
      this.$refs.editsecemailForm.validate(valid => {
        if (valid) {
          console.log(33333);
          const data = {
            email: this.editsecemailForm.email,
            code: this.editsecemailForm.code,
            token: this.$store.state.token
          };
          this.$http
            .post("/user/bind_email", data)
            .then(res => {
              console.log(res);
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.$message({
                    message: this.$t("checkvalid.edit"),
                    type: "success",
                    duration: 1500
                  });
                  this.dialogFormVisible = false;
                  this.userInfo();
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    nextpho(editphoneForm) {
      //两种情况，当在第一步获取完验证码后，需要反向验证   验证码正确  才可以进入下一步  否则需要重新获取填写
      if (this.editphoneForm.code.length <= 0) {
        this.$refs.editphoneForm.validate(valid => {
          if (valid) {
            console.log(3333);
          } else {
            console.log("error submit!!");
            return;
          }
        });
      } else {
        const data = {
          type: "phone",
          code: this.editphoneForm.code,
          token: this.$store.state.token
        };
        this.$http
          .post("/user/check_code", data)
          .then(res => {
            console.log(res);
            if (res.status == 200) {
              if (res.data.status == 0) {
                if (this.active++ > 2) this.active = 2;
                if (this.$refs.editphoneForm) {
                  this.$nextTick(() => {
                    this.$refs.editphoneForm.resetFields();
                  });
                }
              } else {
                this.$message({
                  message: res.data.error,
                  type: "warning",
                  duration: 1500
                });
                return;
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    nextemail(editemailForm) {
      if (this.editemailForm.code.length <= 0) {
        this.$refs.editemailForm.validate(valid => {
          if (valid) {
          } else {
            console.log("error submit!!");
            return;
          }
        });
      } else {
        const data = {
          type: "email",
          code: this.editemailForm.code,
          token: this.$store.state.token
        };
        this.$http
          .post("/user/check_code", data)
          .then(res => {
            console.log(res);
            if (res.status == 200) {
              if (res.data.status == 0) {
                if (this.active++ > 2) this.active = 2;

                if (this.$refs.editsecemailForm) {
                  this.$nextTick(() => {
                    this.$refs.editsecemailForm.resetFields();
                  });
                }
              } else {
                this.$message({
                  message: res.data.error,
                  type: "warning",
                  duration: 1500
                });
                return;
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

      //两种情况，当在第一步获取完验证码后，需要反向验证   验证码正确  才可以进入下一步  否则需要重新获取填写
    },
    // 手机验证码
    getCode(form) {
      //get verification code   setInterval  60秒 countdown
      //setp1与setp2 两次验证用的一个函数   需要做一个判断   因为修改前和修改后的所发的手机号不同
      let that = this;
      let times = 60;
      console.log(form);
      const data = {
        phone: form
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t("checkvalid.codesuccess"),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.code = times + "S";
                if (times == 0) {
                  this.code = this.$t("forgectPhone.codeStr");
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCodephone(form) {
      //get verification code   setInterval  60秒 countdown
      //setp1与setp2 两次验证用的一个函数   需要做一个判断   因为修改前和修改后的所发的手机号不同
      let that = this;
      let times = 60;
      console.log(form);
      const data = {
        phone: form
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t("checkvalid.codesuccess"),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codefirst = times + "S";
                if (times == 0) {
                  this.codefirst = this.$t("forgectPhone.codeStr");
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCodephones(form) {
      //get verification code   setInterval  60秒 countdown
      //setp1与setp2 两次验证用的一个函数   需要做一个判断   因为修改前和修改后的所发的手机号不同
      let that = this;
      let times = 60;
      console.log(form);
      const data = {
        phone: form
      };
      this.$http
        .post("/common/get_phone_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t("checkvalid.codesuccess"),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codephonesecond = times + "S";
                if (times == 0) {
                  this.codephonesecond = this.$t("forgectPhone.codeStr");
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 邮箱验证码
    getCodes(form) {
      let that = this;
      let times = 60;
      const data = {
        email: form
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t("checkvalid.codesuccess"),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codes = times + "S";
                if (times == 0) {
                  this.codes = this.$t("forgectPhone.codeStr");
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCodeemail(form) {
      let that = this;
      let times = 60;
      const data = {
        email: form
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t("checkvalid.codesuccess"),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codesfirst = times + "S";
                if (times == 0) {
                  this.codesfirst = this.$t("forgectPhone.codeStr");
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCodeemails(form) {
      let that = this;
      let times = 60;
      const data = {
        email: form
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t("checkvalid.codesuccess"),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codesecond = times + "S";
                if (times == 0) {
                  this.codesecond = this.$t("forgectPhone.codeStr");
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // edit password quxiao
    offtap(editForm) {
      this.dialogFormVisible = false;
      this.$refs[editForm].resetFields();
    }
  }
};
</script>
<style lang="scss">
.identify {
  width: 800px;
  padding: 30px 0;
  .formcenter.el-form-item {
    display: flex;
    justify-content: center;
  }

  .el-form-item__content {
    float: left;
    margin-left: 0 !important;
  }
  .el-form-item__label {
    margin-left: 80px;
  }
  .el-form-item__label {
    padding-right: 20px;
  }
  .el-input__inner {
    border: 1px solid #1d5a33;
  }
  .el-input.is-disabled .el-input__inner {
    // border-color: #1d5a33;
  }
  .el-dialog {
    .el-form-item__label {
      margin-left: 0px !important;
    }
    .el-dialog__body {
      padding-bottom: 10px !important;
    }
  }
  .spn {
    cursor: pointer;
    display: inline-block;
    color: #248f47;
    margin-left: 5px;
    width: 80px;
    display: inline-block;
    text-align: left;
  }
  .el-button {
    width: auto !important;
    height:40.01px !important;
    line-height: 1;
  }
  .mini.el-button{
    width: auto !important;
    height: 36px !important;
  }
  .ipts {
    width: 150px;
  }
  .spn {
    cursor: pointer;
    display: inline-block;
    color: #248f47;
    margin-left: 5px;
    width: 80px;
    display: inline-block;
    text-align: left;
  }
  .spanwid{
    cursor: pointer;
    display: inline-block;
    color: #248f47;
    margin-left: 5px;
    width: 120px;
    display: inline-block;
    text-align: left;
  }
  .ipts {
    width: 150px;
  }

  .paswidth {
    .el-input {
      width: 186px;
      .el-input__inner {
        width: 186px;
      }
    }
    .inputw.el-input {
      width: 90px;
      .el-input__inner {
        width: 90px;
      }
    }
  }
}
</style>
